export const BRAND = {
  name: "Sena Beauty",
  tagline: "Brow Designer & Micropigmentadora",
  whatsapp: "+351929208109",
  whatsappDisplay: "+351 929 208 109",
  instagram: "bsenabeauty",
  instagramUrl: "https://instagram.com/bsenabeauty",
  bookingUrl:
    "https://www.fresha.com/pt/a/sena-beauty-porto-rua-de-santa-catarina-274-sft0un21?pId=1453738&preview=729d7cb6-6456-4f41-acea-83768e94660c",
  address: {
    street: "Rua de Santa Catarina, 274",
    detail: "2.º andar — Sala 201",
    city: "Porto, Portugal",
    full: "Rua de Santa Catarina, 274, 2.º andar — Sala 201, Porto, Portugal",
  },
};

export const waLink = (text) => {
  const phone = BRAND.whatsapp.replace(/[^0-9]/g, "");
  const msg = encodeURIComponent(text || "Olá Bianca! Gostaria de agendar um procedimento.");
  return `https://wa.me/${phone}?text=${msg}`;
};

export const IMAGES = {
  heroPortrait:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/zggupb9c_IMG_0131.jpeg",
  aboutPortrait:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/rd7y6l4v_IMG_0130.png",
  footerBanner:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/oz1m1zi8_IMG_0129.png",
  brows:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/wrmnjojq_IMG_5109_Original.jpeg",
  lamination:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/84dujlcj_IMG_3198_Original.jpeg",
  nanoblading:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/lh8yyjss_IMG_6173_Original.jpeg",
  microLabial:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/7c0wp69y_E88876A2-B6BB-4E0E-9063-94E686B39E30_Original.png",
  lashes:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/ymca7fw9_8ccefeed-489c-4e7f-8fa2-a457b6ebdacd.jpeg",
  threading:
    "https://images.pexels.com/photos/3997989/pexels-photo-3997989.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
  coloracao:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/5l4qc8l6_IMG_7159.jpeg",
  studio:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/un1wp97i_9a929d85-f049-43dc-b05c-7bc5ddecbc22.jpeg",
  studio2:
    "https://customer-assets.emergentagent.com/job_brow-luxe/artifacts/ew0cd2d7_7ede9380-faef-4d6d-b051-0a87039a13da.jpeg",
};

export const PROCEDURES = [
  {
    key: "design",
    title: "Design de Sobrancelhas",
    description:
      "Desenho feito para você respeitando a sua sobrancelha natural. Todo o procedimento é feito com linha.",
    image: IMAGES.brows,
  },
  {
    key: "nanoblading",
    title: "Nanoblading",
    description:
      "Técnica de longa duração que recria fios reais — densidade, simetria e elegância sob medida.",
    image: IMAGES.nanoblading,
  },
  {
    key: "lamination",
    title: "Brow Lamination",
    description:
      "Alinhamento dos fios para sobrancelhas volumosas, definidas e com efeito de tendência por semanas.",
    image: IMAGES.lamination,
  },
  {
    key: "micro-labial",
    title: "Micropigmentação Labial",
    description:
      "Realça o contorno e devolve cor natural aos lábios, com efeito hidratado e duradouro.",
    image: IMAGES.microLabial,
  },
  {
    key: "coloracao",
    title: "Coloração de Sobrancelhas",
    description:
      "Tonalização personalizada que harmoniza cor e formato, valorizando a expressão do olhar.",
    image: IMAGES.coloracao,
  },
  {
    key: "lashes",
    title: "Lash Lifting",
    description:
      "Curvatura natural das pestanas com efeito duradouro até 6 semanas e sem extensões.",
    image: IMAGES.lashes,
  },
];


export const TESTIMONIALS = [
  {
    name: "Margarida Nunes",
    text:
      "A Bianca é maravilhosa :) mudou completamente as minhas sobrancelhas! Estão lindas e saudáveis graças ao seu excelente trabalho! Não poderia recomendar mais. Finalmente encontrei o melhor sítio no Porto para este serviço! Não vou largar mais.",
  },
  {
    name: "Cristina Barros",
    text:
      "Foi a primeira vez que arranjei as sobrancelhas e num trabalho de nanoblading. Estou muito contente com o resultado: supernatural! A Bianca foi, desde o início, muito clara nas informações, na empatia e a perceber o que eu procurava. Recomendo sem dúvidas!",
  },
  {
    name: "Diana Cruz",
    text:
      "O Sena Beauty é uma verdadeira joia escondida no Porto. A Bianca faz você se sentir à vontade imediatamente com sua abordagem gentil e acolhedora. Ela é delicada, muito profissional e claramente apaixonada pelo seu trabalho. Tive uma ótima experiência e recomendo muito os seus serviços.",
  },
  {
    name: "Nathalia Ferreira",
    text:
      "Nunca tive uma sobrancelha tão elogiada na vida! O design ficou lindo, dá pra ver que tem bastante técnica e experiência. Para além disso, o atendimento foi sensacional. Bianca é muito simpática e solícita. Percebi que genuinamente estava preocupada em me oferecer uma experiência maravilhosa, e isso é um baita diferencial. O ambiente também foi muito bem pensado para trazer conforto. Com certeza, voltarei muitas outras vezes.",
  },
];
